export default __webpack_public_path__ + "static/media/usdc.1fa5e7f4.svg";